import { Container } from "@mui/material";
import ApproveEstimate from "./ApproveEstimate";
const ApproveEstimateAsGuest = () => {
  return (
    <Container maxWidth="lg">
      <ApproveEstimate isGuest={true} />
    </Container>
  );
};

export default ApproveEstimateAsGuest;
